<template>
  <div class="container-xxl-fluid">
    <div class="row">
      <div class="col-lg-4">
        <v-text-field
            v-model="current.currentName"
            label="Cari Adı"
            filled
            dense
            solo
            :error-messages="validationMessages($v.current.currentName, 'Cari Kod')"
            prepend-inner-icon="mdi-format-letter-case"
            @input="$v.current.currentName.$touch()"
            @blur="$v.current.currentName.$touch()"
        >
        </v-text-field>

      </div>
      <div class="col-lg-4">
        <v-text-field
            v-model="current.address"
            label="Adres"
            filled
            dense
            solo
            :error-messages="validationMessages($v.current.address, 'Adres')"
            prepend-inner-icon="mdi-map-marker"
            @input="$v.current.address.$touch()"
            @blur="$v.current.address.$touch()"
        >
        </v-text-field>
      </div>
      <div class="col-lg-4">
        <v-text-field
            v-model="current.city"
            label="İl"
            filled
            dense
            solo
            :error-messages="validationMessages($v.current.city, 'İl')"
            prepend-inner-icon="mdi-city"
            @input="$v.current.city.$touch()"
            @blur="$v.current.city.$touch()"
        >
        </v-text-field>
      </div>
      <div class="col-lg-4">
        <v-text-field
            v-model="current.town"
            label="İlçe"
            filled
            dense
            solo
            :error-messages="validationMessages($v.current.town, 'İlçe')"
            prepend-inner-icon="mdi-home-city"
            @input="$v.current.town.$touch()"
            @blur="$v.current.town.$touch()"
        >
        </v-text-field>
      </div>
      <div class="col-lg-4">
        <v-text-field
            v-model="current.phoneNumber"
            label="Telefon"
            filled
            dense
            solo
            :error-messages="validationMessages($v.current.phoneNumber, 'Telefon')"
            prepend-inner-icon="mdi-phone"
            @input="$v.current.phoneNumber.$touch()"
            @blur="$v.current.phoneNumber.$touch()"
        >
        </v-text-field>
      </div>
      <div class="col-lg-4">
        <v-text-field
            v-model="current.email"
            label="E-Posta"
            filled
            dense
            solo
            :error-messages="validationMessages($v.current.email, 'E-Posta')"
            prepend-inner-icon="mdi-email"
            @input="$v.current.email.$touch()"
            @blur="$v.current.email.$touch()"
        >
        </v-text-field>
      </div>
      <div class="col-lg-4">
        <v-text-field
            v-model="current.web"
            label="Website"
            filled
            dense
            solo
            prepend-inner-icon="mdi-web-box"
        >
        </v-text-field>
      </div>
      <div class="col-lg-4">
        <v-text-field
            v-model="current.taxOffice"
            label="Vergi Dairesi"
            filled
            dense
            solo
            :error-messages="validationMessages($v.current.taxOffice, 'Vergi Dairesi')"
            prepend-inner-icon="mdi-office-building-cog-outline"
            @input="$v.current.taxOffice.$touch()"
            @blur="$v.current.taxOffice.$touch()"
        >
        </v-text-field>
      </div>
      <div class="col-lg-4">
        <v-text-field
            v-model="current.taxNumber"
            label="Vergi No"
            filled
            dense
            solo
            :error-messages="validationMessages($v.current.taxNumber, 'Vergi No')"
            prepend-inner-icon="mdi-numeric"
            @input="$v.current.taxNumber.$touch()"
            @blur="$v.current.taxNumber.$touch()"
        >
        </v-text-field>
      </div>
      <div class="col-lg-4">
        <v-text-field
            v-model="current.trin"
            label="T.C Kimlik No"
            filled
            dense
            solo
            :error-messages="validationMessages($v.current.trin, 'T.C Kimlik No')"
            prepend-inner-icon="mdi-numeric"
            @input="$v.current.trin.$touch()"
            @blur="$v.current.trin.$touch()"
        >
        </v-text-field>
      </div>
      <div class="col-lg-4">
        <v-text-field
            v-model="current.deliveryAddress"
            label="Teslimat Adresi"
            filled
            dense
            solo
            :error-messages="validationMessages($v.current.deliveryAddress, 'Teslimat Adresi')"
            prepend-inner-icon="mdi-location-enter"
            @input="$v.current.deliveryAddress.$touch()"
            @blur="$v.current.deliveryAddress.$touch()"
        >
        </v-text-field>
      </div>
      <div class="col-lg-2">
        <v-text-field
            v-model="current.authorizeFirstName"
            label="Yetkili Ad"
            filled
            dense
            solo
            :error-messages="validationMessages($v.current.authorizeFirstName, 'Yetkili Ad')"
            prepend-inner-icon="mdi-account-lock-open-outline"
            @input="$v.current.authorizeFirstName.$touch()"
            @blur="$v.current.authorizeFirstName.$touch()"
        >
        </v-text-field>
      </div>
      <div class="col-lg-2">
        <v-text-field
            v-model="current.authorizeLastName"
            label="Yetkili Soyad"
            filled
            dense
            solo
            :error-messages="validationMessages($v.current.authorizeLastName, 'Yetkili Soyad')"
            prepend-inner-icon="mdi-account-lock-open-outline"
            @input="$v.current.authorizeLastName.$touch()"
            @blur="$v.current.authorizeLastName.$touch()"
        >
        </v-text-field>
      </div>
      <div class="col-lg-4">
        <v-text-field
            v-model="current.authorizePhoneNumber"
            label="Yetkili Telefon"
            filled
            dense
            solo
            :error-messages="validationMessages($v.current.authorizePhoneNumber, 'Yetkili Telefon')"
            prepend-inner-icon="mdi-phone"
            @input="$v.current.authorizePhoneNumber.$touch()"
            @blur="$v.current.authorizePhoneNumber.$touch()"
        >
        </v-text-field>
      </div>
      <div class="col-lg-4">
        <v-text-field
            v-model="current.authorizeEmail"
            label="Yetkili E-Posta"
            filled
            dense
            solo
            :error-messages="validationMessages($v.current.authorizeEmail, 'Yetkili E-Posta')"
            prepend-inner-icon="mdi-email"
            @input="$v.current.authorizeEmail.$touch()"
            @blur="$v.current.authorizeEmail.$touch()"
        >
        </v-text-field>
      </div>
      <div class="col-lg-4">
        <v-text-field
            v-model="current.expiry"
            label="Vade Gün"
            filled
            dense
            solo
            :error-messages="validationMessages($v.current.expiry, 'Vade Gün')"
            prepend-inner-icon="mdi-clock-end"
            @input="$v.current.expiry.$touch()"
            @blur="$v.current.expiry.$touch()"
        >
        </v-text-field>
      </div>
      <div class="col-lg-4">
        <v-text-field
            v-model="current.riskLimit"
            label="Risk Limit"
            filled
            dense
            solo
            :error-messages="validationMessages($v.current.riskLimit, 'Vade Gün')"
            prepend-inner-icon="mdi-arrow-top-right"
            @input="$v.current.riskLimit.$touch()"
            @blur="$v.current.riskLimit.$touch()"
        >
        </v-text-field>
      </div>
      <div class="col-lg-4">
        <v-select
            v-model="current.paymentType"
            label="Ödeme Tipi"
            :items="paymentMethodList"
            item-text="name"
            item-value="id"
            filled
            dense
            solo
            :error-messages="validationMessages($v.current.paymentType, 'Vade Gün')"
            prepend-inner-icon="mdi-credit-card-outline"
            @input="$v.current.paymentType.$touch()"
            @blur="$v.current.paymentType.$touch()"
        >
        </v-select>
      </div>
      <div class="col-lg-4">
        <v-select
            v-model="current.salesPersonCode"
            label="Plasiyer Kodu"
            filled
            dense
            solo
            :items="salesPersonList"
            item-text="name"
            item-value="code"
            :error-messages="validationMessages($v.current.salesPersonCode, 'Vade Gün')"
            prepend-inner-icon="mdi-account-star-outline"
            @input="$v.current.salesPersonCode.$touch()"
            @blur="$v.current.salesPersonCode.$touch()"
        >
        </v-select>
      </div>
      <div class="col-lg-12 text-end">
        <v-btn depressed ripple color="primary darken-2" @click="saveForm">OLUŞTUR</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import {required, email, maxLength, minLength} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";
import {validationMessages} from "@/validationMessages.js";

import { mapActions, mapState } from 'vuex';

export default {
  mixins: [validationMixin],

  validations() {
    //const self = this;
    return {
      current: {
        currentName: {required},
        address: {required},
        taxOffice: {required},
        taxNumber: {required},
        city: {required},
        town: {required},
        phoneNumber: {required},
        email: {required, email},
        trin: {
          required,
          maxLength: maxLength(11),
          minLength: minLength(11),
        },
        deliveryAddress: {required},
        authorizeFirstName: {required},
        authorizeLastName: {required},
        authorizePhoneNumber: {required},
        authorizeEmail: {required, email},
        expiry: {required},
        riskLimit: {required},
        paymentType: {required},
        salesPersonCode: {required},
      },
    };
  },
  computed:{
    ...mapState("auth",["user"]),
    ...mapState("current",["salesPersonList"]),
    ...mapState("payment",["paymentMethodList"])
  },
  mounted(){
    this.fetchSalesPersonList({
      params: {

      },
      body: {

      }
    })
    this.fetchPaymentMethodList({
      params:{
        userId: this.user.UserId
      },
      body: {

      }
    })
  },
  data() {
    return {
      current: {
        currentName: "",
        address: "",
        taxOffice: "",
        taxNumber: "",
        trin: "",
        deliveryAddress: "",
        authorizeFirstName: "",
        authorizeLastName: "",
        authorizePhoneNumber: "",
        authorizeEmail: "",
        phoneNumber: "",
        faxNumber: "",
        email: "",
        conditionCode: "",
        expiry: 0,
        riskLimit: 0,
        paymentType: null,
        city: "",
        town: "",
        salesPersonCode: "",
        web: "",
      },
    };
  },
  methods: {
    validationMessages,
    ...mapActions("current", ["currentAdd","fetchSalesPersonList"]),
    ...mapActions("payment", ["fetchPaymentMethodList"]),
    async saveForm() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        await this.currentAdd({
          params: {
            userId: this.user.UserId,
          },
          body: {
            currentName: this.current.currentName,
            address: this.current.address,
            taxOffice: this.current.taxOffice,
            taxNumber: this.current.taxNumber,
            trin: this.current.trin,
            deliveryAddress: this.current.deliveryAddress,
            authorizeFirstName: this.current.authorizeFirstName,
            authorizeLastName: this.current.authorizeLastName,
            authorizePhoneNumber: this.current.authorizePhoneNumber,
            authorizeEmail: this.current.authorizeEmail,
            phoneNumber: this.current.phoneNumber,
            faxNumber: this.current.faxNumber,
            email: this.current.email,
            conditionCode: this.current.conditionCode,
            expiry: this.current.expiry,
            riskLimit: this.current.riskLimit,
            paymentType: this.current.paymentType,
            city: this.current.city,
            town: this.current.town,
            salesPersonCode: this.current.salesPersonCode,
            web: this.current.web
          },
          urlSegments: [],
        });

      }
    },
  },
};
</script>